import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { RootState } from "../index";
import { UserModel } from "@/models/usermodel";

export interface AppState {
  authenticated: boolean;
  userprofile: UserModel | {};
}

export interface User {
  username: string;
  age: number;
}

export const state: AppState = {
  authenticated: false,
  userprofile: {},
};

const app: Module<AppState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};

export default app;
